<!--
    描述：场地管理页面
    Created by asq
-->
<template>
	<div class="h100 placeManage">
		<div class="h100" v-if="!routeQuery">
			<left-table ref="leftTable"
							@getCompanyId="getCompanyId"
							@on-reset="resetTable"
							@reset-right="resetRight"></left-table>
		</div>
		<div class="childMain"
			 v-if="routeQuery == 'edit' || routeQuery == 'add'">
			<field-info :companyId="companyId"
						:adressObj="adressObj"></field-info>
		</div>
		<div class="childMain"
			 v-if="routeQuery == 'detail'">
			<edit-meeting :mId="mId"
						  :sId="sId"
						  :companyId="companyId"
						  :adressObj="adressObj"></edit-meeting>
		</div>
		<div class="childMain"
			 v-if="routeQuery == 'Camera'">
			<CameraManagement :adressObj="adressObj"
							  :meetingObj="meetingObj"></CameraManagement>
		</div>
		<div class="childMain"
			 v-if="routeQuery == 'Area'">
			 <right-table ref="rightTable"
							 :adressObj="adressObj"
							 :companyId="companyId"
							 @sendId="receiveId"
							 @on-reset="resetTable"></right-table>
		</div>
	</div>
</template>
<script>
import leftTable from './components/left-table'
import rightTable from './components/right-table'
import editMeeting from './components/edit-meeting-info'
import fieldInfo from './components/field-information'
import CameraManagement from '@/views/operation-management/field-management/components/CameraManagement'
export default {
	name: 'Field-management',
	components: {
		leftTable,
		rightTable,
		editMeeting,
		fieldInfo,
		CameraManagement,
	},
	props: {},
	data() {
		return {
			splitL: 0.25,
			companyId: '', //场地id
			mId: '',
			sid: '',
			adressObj: {},
			meetingObj: {},
		}
	}, // 进入缓存页面
	activated() {
		this.splitL = 0.25
		if(window.sessionStorage.getItem('companyId')){
			this.$router.push({
        name: "Field-management",
        query: {
          type: "Area",
        },
      });
			this.adressObj = JSON.parse(window.sessionStorage.getItem('adressObj'))
			this.resetRight(this.adressObj)
			window.sessionStorage.removeItem('adressObj')
			window.sessionStorage.removeItem('companyId')
		}
	},
	methods: {
		// 接收左侧传来的场地id
		getCompanyId(data) {
			this.adressObj = data
			this.companyId = data.id
		},

		// 接收右侧传来的id
		receiveId(data) {
			this.meetingObj = data
			this.mId = data.id
			this.sId = data.siteId
		},

		// 刷新table
		resetTable() {
			this.$refs.leftTable.getData()
		},

		// 点击左侧场地刷新右侧场地列表
		resetRight(data) {
			console.log(data)
			this.adressObj = data
			this.companyId = data.id
			// if (!num) {
			// 	this.$nextTick(() => {
			// 		this.$refs.rightTable.getDataMeeting(data.id)
			// 	})
			// }
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
	},

	beforeRouteLeave(to, from, next) {
		if (
			from.query.type == 'detail' ||
			from.query.type == 'add' ||
			from.query.type == 'Camera'
		) {
			window.sessionStorage.setItem('companyId', this.companyId)
			window.sessionStorage.setItem('adressObj', JSON.stringify(this.adressObj))
		}else if (from.query.type == 'Area' ){
			window.sessionStorage.removeItem('companyId')
		}
		next()
	},
}
</script>
<style lang="less" scoped>
.placeManage {
	/deep/ .right-pane {
		background-color: #fff;
		z-index: 2;
	}
	.childMain {
		height: 100%;
	}
}
</style>
